import React, { Component, PropTypes } from "react";
import LeftComponent from "components/Authorization/LeftComponent";
import { connect } from "react-redux";
import actions from "actions";
import {
  adminConfirmLogin,
  adminResendConfirmCode,
} from "../../../actions/auth";
import PasswordField from "../../../components/InputField/PasswordField";
const { login } = actions;

class LoginAdminConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = { code: "", passwordType: "password" };
  }

  onFieldChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onPasswordTypeChange = (status) => {
    this.setState({
      passwordType: status ? "text" : "password",
    });
  };

  onSubmit = (e) => {
    e.preventDefault();
    const { code } = this.state;
    const auth_token = this.props.location.query.token;
    this.props.adminConfirmLogin({ code, auth_token });
  };

  handleResendCode = () => {
    this.setState({ code: "" });
    const auth_token = this.props.location.query.token;
    this.props.adminResendConfirmCode({ auth_token });
  };

  render() {
    const { code, passwordType } = this.state;

    return (
      <main className="">
        <div className="container_content_signin">
          <LeftComponent />
          <div className="container_global_signin">
            <h2 className="signin_title">Enter code from mail</h2>
            <div className="container_signin row">
              <form className="col s12" onSubmit={this.onSubmit}>
                <div className="row">
                  <PasswordField
                    label="Code"
                    onChange={this.onFieldChange}
                    field_name="code"
                    value={code}
                    showPassword={passwordType == "text"}
                    onPasswordChangeVisibility={this.onPasswordTypeChange}
                    className="col s12"
                  />
                  <div className="submit_center col s12">
                    <input
                      className="container_signin_button"
                      type="submit"
                      name=""
                      value="Sign In"
                    />
                  </div>
                </div>
              </form>
            </div>
            <button
              className="container_signin_button"
              style={{
                marginTop: 0,
                display: "block",
                marginLeft: "auto",
                marginRight: "auto",
              }}
              onClick={this.handleResendCode}
            >
              Resend code
            </button>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => {
  return {
    adminConfirmLogin: (payload) => {
      dispatch(adminConfirmLogin(payload));
    },
    adminResendConfirmCode: (payload) => {
      dispatch(adminResendConfirmCode(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginAdminConfirm);



// WEBPACK FOOTER //
// ./src/containers/Authorization/LoginAdminConfirm/index.jsx